import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import { useSearchParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { Eye, Edit, Trash2 } from "react-feather";
import { _Get } from "../../ApiEndPoint/ApiCalling";
import { Create_Transporter_List } from "../../ApiEndPoint/Api";
import axiosConfig from "../../AxiosConfig"
const Transporter = () => {
  const [, setSearchParams] = useSearchParams();

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // Agar aapke project me user/database context hai
  const db = JSON.parse(localStorage.getItem("userData"));
  const database = db.database;

  // =========================
  // GET TRANSPORTER LIST
  // =========================
  const fetchTransporters = async () => {
    try {
      setLoading(true);

    //   const res = await _Get(Create_Transporter_List, database);
const res = await axiosConfig.get(
  `/transporter/view-transporter/${database}`
);
      console.log("Transporter API Response:", res);

      const value = res?.data?.Transporter || [];

      setRowData(value);
    } catch (error) {
      console.log("Transporter List Error:", error);
      setRowData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransporters();
  }, []);

  // =========================
  // SEARCH
  // =========================
  const filteredData = rowData.filter((item) => {
    const searchValue = search.toLowerCase();

    return (
      item?.id?.toString().toLowerCase().includes(searchValue) ||
      item?.companyName?.toLowerCase().includes(searchValue) ||
      item?.contactNumber?.toString().includes(searchValue) ||
      item?.name?.toLowerCase().includes(searchValue) ||
      item?.email?.toLowerCase().includes(searchValue) ||
      item?.pincode?.toString().includes(searchValue) ||
      item?.city?.toLowerCase().includes(searchValue) ||
      item?.state?.toLowerCase().includes(searchValue) ||
      item?.status?.toLowerCase().includes(searchValue)
    );
  });

  // =========================
  // DELETE
  // =========================
  const runthisfunction = async (id) => {
    console.log("Delete Transporter:", id);

    // Yaha aapka delete API call aayega
  };

  // =========================
  // COLUMN DEFS
  // =========================
  const columnDefs = [
  {
    headerName: "ID",
    field: "id",
    width: 150,
    sortable: true,
    cellRenderer: (params) => (
      <div 
      style={{ width: "100%" }} >
        {params?.data?.id || "-"}
      </div>
    ),
  },

  {
    headerName: "Company Name",
    field: "companyName",
    width: 180,
    sortable: true,
    cellRenderer: (params) => (
      <div

        
        style={{ cursor: "pointer",width: "100%" }}
        onClick={() =>
          setSearchParams({
            view: "create-transporter",
            id: params?.data?._id,
          })
        }
      >
        {params?.data?.companyName || "-"}
      </div>
    ),
  },

  {
    headerName: "Contact Number",
    field: "contactNumber",
    width: 170,
    sortable: true,
    cellRenderer: (params) => (
      <div  style={{ width: "100%" }}>
        {params?.data?.contactNumber || "-"}
      </div>
    ),
  },

  {
    headerName: "Name",
    field: "name",
    width: 200,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.name || "-"}
      </div>
    ),
  },

  {
    headerName: "GST Number",
    field: "gstNumber",
    width: 180,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.gstNumber || "-"}
      </div>
    ),
  },

  {
    headerName: "Pin Code",
    field: "pincode",
    width: 120,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.pincode || "-"}
      </div>
    ),
  },

  {
    headerName: "City",
    field: "city",
    width: 180,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.city || "-"}
      </div>
    ),
  },

  {
    headerName: "State",
    field: "state",
    width: 170,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.state || "-"}
      </div>
    ),
  },

  {
    headerName: "Opening Balance",
    field: "OpeningBalance",
    width: 160,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.OpeningBalance ?? "-"}
      </div>
    ),
  },

  {
    headerName: "Type",
    field: "Type",
    width: 120,
    sortable: true,
    cellRenderer: (params) => (
      <div className="text-capitalize">
        {params?.data?.Type || "-"}
      </div>
    ),
  },

  {
    headerName: "Status",
    field: "status",
    width: 120,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.status || "-"}
      </div>
    ),
  },

  {
    headerName: "Created Date",
    field: "createdAt",
    width: 150,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.createdAt
          ? params.data.createdAt.split("T")[0]
          : "-"}
      </div>
    ),
  },

  {
    headerName: "Updated Date",
    field: "updatedAt",
    width: 150,
    sortable: true,
    cellRenderer: (params) => (
      <div >
        {params?.data?.updatedAt
          ? params.data.updatedAt.split("T")[0]
          : "-"}
      </div>
    ),
  },

  {
    headerName: "Actions",
    field: "actions",
    width: 130,
    sortable: false,
    filter: false,

    cellRenderer: (params) => (
      <div className="d-flex justify-content-center align-items-center gap-1">

        {/* VIEW */}
        <span
          title="View"
          style={{
            border: "1px solid white",
            padding: "4px",
            borderRadius: "10px",
            backgroundColor: "#39cccc",
            cursor: "pointer",
            display: "flex",
          }}
          onClick={() =>
            setSearchParams({
              view: "create-transporter",
              id: params?.data?._id,
            })
          }
        >
          <Eye size={11} color="white" />
        </span>

        {/* EDIT */}
        <span
          title="Edit"
          style={{
            border: "1px solid white",
            padding: "4px",
            borderRadius: "10px",
            backgroundColor: "rgb(212, 111, 16)",
            cursor: "pointer",
            display: "flex",
          }}
          onClick={() =>
            setSearchParams({
              view: "create-transporter",
              id: params?.data?._id,
            })
          }
        >
          <Edit size={11} color="white" />
        </span>

        {/* DELETE */}
        <span
          title="Delete"
          style={{
            border: "1px solid white",
            padding: "4px",
            borderRadius: "10px",
            backgroundColor: "rgb(236, 24, 9)",
            cursor: "pointer",
            display: "flex",
          }}
          onClick={() =>
            runthisfunction(params?.data?._id)
          }
        >
          <Trash2 size={11} color="white" />
        </span>

      </div>
    ),
  },
];

  return (
    <div className="p-3">

      {/* ================= HEADER ================= */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">
          Transporter List
        </h5>

        <Button
          color="primary"
          onClick={() =>
            setSearchParams({
              view: "create-transporter",
            })
          }
        >
          + Transporter
        </Button>
      </div>

      {/* ================= SEARCH ================= */}
      <div className="card mb-3">
        <div className="card-body">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-0">
                <Label>
                  Search
                </Label>

                <Input
                  type="text"
                  placeholder="Search transporter..."
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                />
              </FormGroup>
            </div>
          </div>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="card">
        <div className="card-body">

          <div
            className="ag-theme-alpine"
            style={{
              width: "100%",
              height: "600px",
            }}
          >
       <AgGridReact
  rowData={filteredData}
  columnDefs={columnDefs}
  pagination={true}
  paginationPageSize={10}
  suppressCellFocus={true}
  defaultColDef={{
    resizable: true,
    sortable: true,
  }}
  overlayLoadingTemplate="Loading..."
  overlayNoRowsTemplate="No Transporter Found"
/>
          </div>

        </div>
      </div>

    </div>
  );
};

export default Transporter;